import React, { useEffect } from 'react';
import './Contactus.css';

const ContactUs = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="page-container">
      <div className="container">
        <button className="back-button" onClick={() => window.history.back()}>
          <span>←</span><span>Back to Home</span>
        </button>

        <h1>Contact Us</h1>
        <p className="subtitle">Get in touch with our team. We're here to help 24/7.</p>

        <div className="contact-methods">
          <div className="contact-card">
            <div className="contact-icon">💬</div>
            <h3>Live Chat</h3>
            <p>Chat with our support team</p>
            <button className="contact-btn">Start Chat</button>
          </div>

          <div className="contact-card">
            <div className="contact-icon">📧</div>
            <h3>Email Support</h3>
            <p>support@BGI Assets.com</p>
            <button className="contact-btn">Send Email</button>
          </div>

          <div className="contact-card">
            <div className="contact-icon">📞</div>
            <h3>Phone Support</h3>
            <p>+1-629 298 9186</p>
            <button className="contact-btn">Call Now</button>
          </div>

          <div className="contact-card">
            <div className="contact-icon">📱</div>
            <h3>WhatsApp</h3>
            <p>+1-629 298 9186</p>
            <button className="contact-btn">Message Us</button>
          </div>
        </div>

        <div className="form-section">
          <h2>Send Us a Message</h2>
          <form>
            <div className="form-group">
              <label>Name *</label>
              <input type="text" required />
            </div>
            <div className="form-group">
              <label>Email *</label>
              <input type="email" required />
            </div>
            <div className="form-group">
              <label>Subject *</label>
              <input type="text" required />
            </div>
            <div className="form-group">
              <label>Message *</label>
              <textarea rows="5" required></textarea>
            </div>
            <button type="submit" className="submit-btn">Send Message</button>
          </form>
        </div>

        <div className="section">
          <h2>Office Address</h2>
          <p>Raw Trading Ltd<br/>
          Suite 1, Second Floor<br/>
          Sound & Vision House<br/>
          Francis Rachel Street<br/>
          Victoria, Mahe, Seychelles</p>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;